import React from 'react'
import { PageTitle } from '../../../../../_metronic/layout/core'
import { RecordsKeeperAIRecordsFilesBreadCrumbs } from '../../core/_constants'
import { useIntl } from 'react-intl'
import { InfoCard2 } from '../../../widgets/components/UI/InfoCard2'
import { FileRequestsDataTable } from './FileRequestsDataTable'

const FileRequest = () => {
    const { formatMessage } = useIntl()
    return (
        <div>
            <PageTitle
                breadcrumbs={RecordsKeeperAIRecordsFilesBreadCrumbs}
                description={formatMessage({ id: 'File Request' })}
            >
                {formatMessage({ id: 'RecordsKeeper AI' })}
            </PageTitle>
            <div className='px-6'>
                <InfoCard2 title={'Managing File Requests in RecordsKeeper'} desc={'This page allows you to create, track, and manage file requests. Easily request files from team members or external contacts, monitor the status of requests, and view uploaded files in one central location. Use the request link to share, and track the urgency and progress of each request.'} slug={'https://help.recordskeeper.ai/en/articles/10368113-how-to-manage-file-requests-in-recordskeeper-ai'} />
                <FileRequestsDataTable />
            </div>
        </div>
    )
}

export default FileRequest
